import { render } from "./PersonalInventory.vue?vue&type=template&id=7cf34988&scoped=true"
import script from "./PersonalInventory.vue?vue&type=script&lang=js"
export * from "./PersonalInventory.vue?vue&type=script&lang=js"

import "./PersonalInventory.vue?vue&type=style&index=0&id=7cf34988&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/magic-shop-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cf34988"]])

export default __exports__